import { APP_STORE_URL, PLAY_STORE_URL } from "@/lib/stores";
import { isStoreApp } from "@/lib/platform";
import { cn } from "@/lib/utils";
import { t } from "@shared/i18n";

const badge = "press inline-flex h-12 items-center gap-2.5 rounded-[10px] border border-[#a6a6a6] bg-black pl-3 pr-4 text-white transition-opacity hover:opacity-85";

export function AppStoreBadge({ className }: { className?: string }) {
  if (!APP_STORE_URL) return null;
  return (
    <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={cn(badge, className)} aria-label={t("Télécharger dans l'App Store")}>
      <svg viewBox="0 0 24 24" className="size-7 fill-white" aria-hidden>
        <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="text-[10px]">{t("Télécharger dans")}</span>
        <span className="mt-0.5 text-[19px] font-semibold tracking-tight">{t("l'App Store")}</span>
      </span>
    </a>
  );
}

export function GooglePlayBadge({ className }: { className?: string }) {
  return (
    <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className={cn(badge, className)} aria-label={t("Disponible sur Google Play")}>
      <svg viewBox="0 0 24 24" className="size-7" aria-hidden>
        <path fill="#4285F4" d="M3.6 2.2 13.3 12l-9.7 9.8c-.4-.2-.6-.6-.6-1.1V3.3c0-.5.2-.9.6-1.1Z" />
        <path fill="#34A853" d="M3.6 2.2c.4-.2.9-.2 1.4.1l11.4 6.5-3.1 3.2Z" />
        <path fill="#EA4335" d="m13.3 12 3.1 3.2L5 21.7c-.5.3-1 .3-1.4.1Z" />
        <path fill="#FBBC04" d="m16.4 8.8 3.7 2.1c1.2.7 1.2 1.5 0 2.2l-3.7 2.1-3.1-3.2Z" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="text-[10px] uppercase tracking-wide">{t("Disponible sur")}</span>
        <span className="mt-0.5 text-[19px] font-semibold tracking-tight">Google Play</span>
      </span>
    </a>
  );
}

/** Boutons des stores (masqués dans les applications elles-mêmes). */
export function StoreBadges({ className }: { className?: string }) {
  if (isStoreApp) return null;
  return (
    <div className={cn("flex flex-wrap items-center gap-3", className)}>
      <AppStoreBadge />
      <GooglePlayBadge />
    </div>
  );
}
